export default __webpack_public_path__ + "static/media/image-form.d16a32e9.svg";